<template>
  <div class="contain">
    <!-- 검색 영역 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        :label-position="$device.mobile ? `top` : `left`"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :md="6">
            <el-form-item :label="$t('언어')">
              <lan-combo
                :data="lans"
                :label="$t('전체')"
                :model="searchForm.lanId"
                @change="searchForm.lanId = $event"></lan-combo>
            </el-form-item>
          </el-col>
          <el-col :md="6">
            <el-form-item :label="$t('약관 타입')">
              <code-combo
                :data="termsTp"
                :label="$t('전체')"
                :model="searchForm.termsTpCd"
                @change="searchForm.termsTpCd = $event.cd"></code-combo>
            </el-form-item>
          </el-col>
          <el-col :md="6">
            <el-form-item :label="$t('사용 가능 여부')">
              <combo
                :data="mainVue.code.useYn"
                :label="$t('전체')"
                :model="searchForm.useYn"
                @change="searchForm.useYn = $event"></combo>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼 -->
    <div class="buttons" ref="buttons">
      <el-button v-if="checkAuthActionAccess('TermsSearch')" :size="size" @click="search" icon="el-icon-search">{{
        $t('검색')
      }}</el-button>
      <el-button
        v-if="checkAuthActionAccess('TermsAdd')"
        :size="size"
        @click="add"
        icon="el-icon-circle-plus-outline"
        :disabled="btn.addDisabled"
        >{{ $t('등록') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('TermsUp')"
        :size="size"
        @click="up"
        icon="el-icon-edit-outline"
        :disabled="btn.upDisabled"
        >{{ $t('수정') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('TermsDel')"
        :size="size"
        @click="del"
        icon="el-icon-remove-outline"
        :disabled="btn.delDisabled"
        >{{ $t('삭제') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('TermsAdd') || checkAuthActionAccess('TermsUp')"
        :size="size"
        @click="save"
        icon="el-icon-check"
        :disabled="btn.saveDisabled"
        style="float: right"
        class="hide-on-mobile"
        >{{ $t('저장') }}</el-button
      >
    </div>

    <!-- 리스트 -->
    <el-row :gutter="20">
      <el-col :md="12">
        <el-table
          :height="tableHeight"
          ref="table"
          border
          stripe
          highlight-current-row
          tooltip-effect="dark"
          :data="tableData"
          :size="size"
          :empty-text="$t('데이타 없음')"
          @row-click="handleRowClick"
          @select="handleRowChecked"
          @select-all="handleRowChecked">
          <el-table-column
            :label="tableData.length.toString()"
            type="index"
            width="55"
            align="center"
            sortable
            :fixed="!$device.mobile"
            label-class-name="data_cnt"></el-table-column>
          <el-table-column type="selection" width="45" align="center" :fixed="!$device.mobile"></el-table-column>
          <el-table-column
            :label="$t('타이틀')"
            prop="termsTitle"
            min-width="200"
            sortable
            show-overflow-tooltip></el-table-column>
          <el-table-column :label="$t('언어')" prop="lan.nm" width="90" align="center"></el-table-column>
          <el-table-column
            :label="$t('약관 타입')"
            prop="termsTp.nmLan"
            min-width="200"
            sortable
            show-overflow-tooltip></el-table-column>
          <el-table-column
            :label="$t('사용 가능 여부')"
            prop="useYn"
            min-width="120"
            align="center"
            :formatter="mainVue.formatterCode"></el-table-column>
        </el-table>
      </el-col>
      <el-col :md="12">
        <el-card shadow="never" :style="{ height: inputHeight + 'px' }" class="input-menu">
          <div slot="header">
            <span>{{ $t('약관') }}</span>
            <span v-if="'I' == inputForm.statu">{{ $t('추가') }}</span>
            <span v-if="'U' == inputForm.statu">{{ $t('수정') }}</span>
          </div>
          <div>
            <el-form
              :model="inputForm"
              :label-width="$device.mobile ? `` : `120px`"
              label-suffix=":"
              :size="size"
              :disabled="fromDisabled"
              @submit.native.prevent>
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item :label="$t('언어')" :error="formError['lan.id']" required>
                    <lan-combo :data="lans" :model="inputForm.lan.id" @change="inputForm.lan.id = $event"></lan-combo>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('약관 타입')" :error="formError['termsTp.cd']" required>
                    <code-combo
                      :data="termsTp"
                      :model="inputForm.termsTp"
                      @change="inputForm.termsTp = $event"></code-combo>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('제목')" :error="formError.termsTitle" required>
                    <el-input v-model="inputForm.termsTitle" maxlength="50" clearable show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('사용 가능 여부')" required>
                    <combo
                      :data="mainVue.code.useYn"
                      :model="inputForm.useYn"
                      @change="inputForm.useYn = $event"></combo>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item :label="$t('내용')" :error="formError.content" required>
                    <el-input
                      type="textarea"
                      v-model="inputForm.content"
                      :autosize="{ minRows: 6, maxRows: 16 }"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>

            <el-button
              v-if="checkAuthActionAccess('TermsAdd') || checkAuthActionAccess('TermsUp')"
              :size="size"
              @click="save"
              icon="el-icon-check"
              :disabled="btn.saveDisabled"
              style="float: right"
              class="hide-on-desktop"
              >{{ $t('저장') }}</el-button
            >
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { initData } from '@/utils/constants'
import mainVueMixin from '@/mixins/mainVueMixin'
import { util } from '@/mixins/utilMixin'

export default {
  mixins: [mainVueMixin],

  data: function () {
    var data = initData()
    data.url = '/terms'

    data.lans = []
    data.termsTp = []

    data.searchForm = this.initSearchForm()
    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()

    return data
  },
  created: function () {
    this.initLan()
    this.initClientTp()
    this.search()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  watch: {
    'inputForm.lan.id': function (newVal, oldVal) {
      if ('' != newVal) {
        this.chkLanAndTermsTp()
      }
    },
    'inputForm.termsTp.cd': function (newVal, oldVal) {
      if ('' != newVal) {
        this.chkLanAndTermsTp()
      }
    },
  },
  methods: {
    // 검색 조건 초기화
    initSearchForm: function () {
      return {
        lanId: '',
        termsTpCd: 0,
        useYn: 'Y',
      }
    },
    // 입력폼 초기화
    initInputForm: function () {
      return {
        statu: 'I',
        title: '',
        termsCd: 0,
        lan: { id: null, nm: '' },
        termsTp: { cd: null, nm: '' },
        termsTitle: '',
        content: '',
        useYn: 'Y',
      }
    },
    // 오류 메세지 초기화
    initFormError: function () {
      return {
        'lan.id': '',
        'termsTp.cd': '',
        termsTitle: '',
        content: '',
      }
    },
    // 그리드 선택 이벤트
    handleRowClick: function (val) {
      if (null != val) {
        this.btn.upDisabled = false
      }
      this.selectData = val
    },
    // 체크 박스 체크 이벤트
    handleRowChecked: function (selection, row) {
      if (selection.length > 0) {
        this.btn.delDisabled = false
      } else {
        this.btn.delDisabled = true
      }

      this.checkedData = []

      for (var i = 0, len = selection.length; i < len; i++) {
        this.checkedData[this.checkedData.length] = selection[i].termsCd
      }
    },
    // 언어 데이타 조회
    initLan: function () {
      this.mainVue.$axios.search(
        '/language',
        null,
        function (result) {
          this.lans = result
        }.bind(this),
        false
      )
    },
    // 약관 타입 데이타 조회
    initClientTp: function () {
      this.mainVue.$axios.search(
        '/code/getCode/TERMS_TP',
        null,
        function (result) {
          this.termsTp = result
        }.bind(this),
        false
      )
    },
    // 추가
    add: function () {
      this.inputForm = this.initInputForm()

      this.inputForm.lan = this.lans.length > 0 ? util.copyObj(this.lans[0]) : { cd: null, nm: '' }
      this.inputForm.termsTp = this.termsTp.length > 0 ? util.copyObj(this.termsTp[0]) : { cd: null, nm: '' }

      this.formError = this.initFormError()

      this.btn.saveDisabled = false
      this.fromDisabled = false

      this.chkLanAndTermsTp()
    },
    // 수정
    up: function () {
      this.mainVue.$axios.get(
        this.url + '/' + this.selectData.termsCd,
        function (result) {
          result.statu = 'U'

          this.inputForm = result

          this.formError = this.initFormError()

          this.btn.saveDisabled = false
          this.fromDisabled = false
        }.bind(this),
        true
      )
    },
    // 조회
    search: function () {
      this.mainVue.$axios.search(
        this.url,
        this.searchForm,
        function (result) {
          this.tableData = result

          this.btn.addDisabled = false
          this.btn.upDisabled = true
          this.btn.delDisabled = true
          this.btn.saveDisabled = true
          this.fromDisabled = true

          this.inputForm = this.initInputForm()
          this.formError = this.initFormError()
        }.bind(this),
        false
      )
    },
    // 삭제
    del: function () {
      this.mainVue
        .$confirm(this.$t('약관 정보를 삭제 하시겠습니까?'), this.mainVue.appMsg.systemAlterTitle, {
          confirmButtonText: this.$t('삭제'),
          cancelButtonText: this.$t('취소'),
          type: 'info',
        })
        .then(
          function () {
            this.mainVue.$axios.del(
              this.url + '/' + this.checkedData.join(','),
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                this.search()
              }.bind(this),
              true
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('삭제 취소') })
          }.bind(this)
        )
    },
    // 저장
    save: function () {
      this.formError = this.initFormError()

      if ('I' === this.inputForm.statu) {
        this.mainVue.$axios.add(
          this.url,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
            this.search()
          }.bind(this),
          true
        )
      } else {
        this.mainVue.$axios.up(
          this.url + '/' + this.inputForm.termsCd,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
            this.search()
          }.bind(this),
          true
        )
      }
    },
    chkLanAndTermsTp: function () {
      if (!util.isEmpty(this.inputForm.lan.id) && !util.isEmpty(this.inputForm.termsTp.cd)) {
        // 서버에서 언어 기준으로 체크 함
        this.mainVue.$axios.patchNonLoading(
          this.url + '/chk/' + this.inputForm.lan.id + '/' + this.inputForm.termsTp.cd,
          null,
          null,
          function (result) {
            if ('' == result || this.inputForm.termsCd == result.termsCd) {
              this.formError['termsTp.cd'] = ''
              this.btn.saveDisabled = false
            } else {
              this.formError['termsTp.cd'] = this.$t('이미 사용중인 약관 정보입니다.')
              this.btn.saveDisabled = true
            }
          }.bind(this),
          false
        )
      }
    },
  },
}
</script>
